import axios from './HTTP'

export default {
  getFilters (userId, callback) {
    axios
      .get('/api/hr/filters.json', { params: { user_id: userId } })
      .then(response => ( callback(response.data) ))
  },

  getEmployeeStats(params, callback) {
    axios
      .get('/api/hr/employee-stats.json', { params: { user_id: params.userId } })
      .then(response => ( callback(response.data) ))
  },
}
